import { useLang } from "../LanguageContext";
import { translations } from "../data/translations";
import { companyConfig } from "../data/config";
import { motion } from "framer-motion";
import { Mail, Phone, MapPin } from "lucide-react";

export default function ContactSection() {
  const { lang } = useLang();
  const t = translations[lang];

  return (
    <section id="contact" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-brand-blue mb-4">
            {t.contact?.title || "Kontakt"}
          </h2>
          <p className="text-gray-600">
            {t.contact?.subtitle || "Sprechen Sie uns an"}
          </p>
        </motion.div>

        <div className="max-w-2xl mx-auto bg-white rounded-2xl shadow-sm p-8">
          <div className="space-y-6">
            <div className="flex items-start gap-4">
              <Mail className="w-6 h-6 text-brand-blue mt-1" />
              <div>
                <p className="text-sm text-gray-500">
                  {t.contact?.emailLabel || "E-Mail"}
                </p>

                <div className="flex flex-col">
                  {companyConfig.emails.map((email) => (
                    <a
                      key={email}
                      href={`mailto:${email}`}
                      className="text-gray-900 hover:text-brand-blue transition"
                    >
                      {email}
                    </a>
                  ))}
                </div>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <Phone className="w-6 h-6 text-brand-blue mt-1" />
              <div>
                <p className="text-sm text-gray-500">
                  {t.contact?.phoneLabel || "Telefon"}
                </p>
                <a
                  href={`tel:${companyConfig.phone.replace(/\s+/g, "")}`}
                  className="text-gray-900 hover:text-brand-blue transition"
                >
                  {companyConfig.phone}
                </a>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <MapPin className="w-6 h-6 text-brand-blue mt-1" />
              <div>
                <p className="text-sm text-gray-500">
                  {t.contact?.addressLabel || "Adresse"}
                </p>
                <a
                  href={companyConfig.mapsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-900 hover:text-brand-blue transition"
                >
                  {companyConfig.location}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
